<template lang="pug">
  div
    span {{ symbol }}
    span {{ price }}
</template>

<script>
  export default {
    props: {
      price: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        symbol: 'S/.'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/Price.vue